var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logotype",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 404.51 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.58,73.12l-0.28-6.34c-0.37-8.57-0.28-13.61-9.42-16.22c5.97-0.56,8.57-5.5,8.57-11.09v-4.48 c0-8.11-4.11-14.91-14.44-14.91h-29.92v59.84h17.25V58.21c9.6,0,10.44,2.79,10.72,7.93l0.37,7.17c0.09,2.33,0.24,4.52,0.98,6.61 h17.15C171.82,77.89,171.68,75.45,171.58,73.12z M149.03,44.6h-5.68V33.69h4.57c4.57,0,5.41,2.05,5.41,5.87 C153.31,42.08,152.94,44.6,149.03,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.68,31.83h-14.91c-8.39,0-14.54,4.94-14.54,13.24V66.7c0,8.3,6.15,13.24,14.54,13.24h14.91 c8.39,0,14.54-4.94,14.54-13.24V45.07C223.22,36.77,217.07,31.83,208.68,31.83z M206.07,63.42c0,2.42-0.47,5.12-4.85,5.12 s-4.85-2.7-4.85-5.12v-15c0-2.42,0.47-5.22,4.85-5.22s4.85,2.79,4.85,5.22V63.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.97,79.93 275.79,79.93 259.48,54.38 273.93,31.83 255.57,31.83 250.53,40.41 245.03,31.83 226.2,31.83  240.93,54.85 224.71,79.93 243.07,79.93 249.79,68.74  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.66,43.2V31.83h-7.92V20.45h-1.86L278.59,30.7v35.98c0,8.3,6.15,13.24,14.54,13.24h10.99l-0.1-11.37h-3.45 c-4.38,0-4.85-2.7-4.85-5.12V43.2L303.66,43.2L303.66,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,58.2V45.06c0-8.3-6.15-13.24-14.54-13.24h-13.98c-8.39,0-14.54,4.94-14.54,13.24v21.63 c0,8.3,6.15,13.24,14.54,13.24h13.98c8.39,0,14.54-4.94,14.54-13.24v-3.26h-17.15c0,2.42-0.37,5.12-4.38,5.12 c-3.92,0-4.38-2.7-4.38-5.12v-5.22h25.91V58.2z M327.52,48.42c0-2.42,0.47-5.22,4.38-5.22c4.01,0,4.38,2.79,4.38,5.22v2.52h-8.76 V48.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.51,48.32v-3.26c0-8.3-6.15-13.24-14.54-13.24h-13.98c-8.39,0-14.54,4.94-14.54,13.24v21.63 c0,8.3,6.15,13.24,14.54,13.24h13.98c8.39,0,14.54-4.94,14.54-13.24v-3.26h-17.15c0,2.42-0.37,5.12-3.92,5.12 c-4.38,0-4.85-2.7-4.85-5.12v-15c0-2.42,0.47-5.22,4.85-5.22c3.54,0,3.92,2.7,3.92,5.12h17.15V48.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.01,
    style: {
      fill: "#0091D3"
    },
    width: 100,
    height: 100
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.29,50c0,20.07-9.06,38.02-23.32,50h11.7c12.21-13.1,19.7-30.67,19.7-50s-7.49-36.89-19.7-50h-11.7 C56.22,11.98,65.29,29.93,65.29,50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.78,50C42.78,26.37,23.62,7.22,0,7.22v85.57C23.63,92.78,42.78,73.64,42.78,50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,50c0,27.61-22.38,50-50,50h29.52C46.6,89.89,58.06,71.29,58.06,50S46.6,10.11,29.52,0H0C27.61,0.01,50,22.39,50,50z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.60ae7de317fab7b86fe80c4de3d0d08a.svg";
export { ForwardRef as ReactComponent };